import React, { useRef } from 'react';
import { faFillDrip } from '@fortawesome/pro-regular-svg-icons';
import { useAdmin, useUpdateShape } from 'hooks';
import ToolBarColorPicker from '../components/ToolbarColorPicker';
import ActionsContainer from '../components/ActionsContainer';
import VerticalDivider from '../components/VerticalDivider';
import './ActionBarCalendar.scss';
import DayStyle from './components/DayStyle';
import EventStyle from './components/EventStyle';
import CustomSelect from '../components/CustomSelect';
import DayLabelStyle from './components/DayLabelStyle';
import Position from './components/Position';
import DayTopBorderStyle from './components/DayTopBorder';
import CalendarSizesStyle from './components/CalendarSIzes';

/**
 * @param {Object} props
 * @param {boolean} [props.hide]
 * @param {import('actions/scene.types').CalendarShape} props.shape Calendar shape being edited.
 * @returns {React.ReactElement}
 */
export const CalendarFooter = ({ hide, shape }) => {
  const onChange = useUpdateShape(shape.id);
  console.log('shape:', shape);
  const admin = useAdmin();
  const toolbarRef = useRef();

  return (
    <ActionsContainer hide={hide} maxWidth={admin ? 740 : undefined}>
      {!admin ? (
        <>
          <DayStyle object={shape} toolbarRef={toolbarRef} />
          <VerticalDivider />
        </>
      ) : null}

      {!admin ? (
        <>
          <EventStyle object={shape} toolbarRef={toolbarRef} />
          <VerticalDivider />
        </>
      ) : null}

      {!admin ? (
        <>
          <DayLabelStyle shape={shape} toolbarRef={toolbarRef} />
          <VerticalDivider />
        </>
      ) : null}

      <Position shape={shape} />

      {!admin ? (
        <>
          <DayTopBorderStyle shape={shape} toolbarRef={toolbarRef} />
          <VerticalDivider />
        </>
      ) : null}

      {!admin ? (
        <>
          <CalendarSizesStyle shape={shape} toolbarRef={toolbarRef} />
          <VerticalDivider />
        </>
      ) : null}

      {!admin ? (
        <>
          <CustomSelect
            options={[
              {
                value: 1,
                label: '1',
              },
              {
                value: 2,
                label: '2',
              },
            ]}
            value={shape.calendarType}
            onChange={(calendarType) => {
              onChange({ calendarType });
            }}
          />

          <ToolBarColorPicker
            initialValue={shape.backgroundColor}
            toolbarRef={toolbarRef}
            onChange={(value) => onChange({ backgroundColor: value })}
            icon={faFillDrip}
            disableAlpha={false}
            disableIconColorMatching
          />
        </>
      ) : null}
    </ActionsContainer>
  );
};

export default CalendarFooter;
